import MediaType from './Constants/MediaType';

class Playback {
    licenseUrl = '';
    releasePid = '';
    manifests = [];
    mediaType = MediaType.UNSET;
    asset = null;
    media = null;
    isEnabled = false;

    constructor() {
        Object.seal(this);
    }

    get isLive() {
        return this.mediaType === MediaType.LIVE;
    }
}

export default Playback;
